var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('homeHeader',{attrs:{"title":"接口分析"}}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"card"},[_c('div',{style:({
          height: _vm.tableHeight,
        }),attrs:{"id":"frame"}},[_c('iframe',{staticClass:"iframe-dv",attrs:{"src":_vm.iframeUrl,"frameborder":"0","width":"100%","height":_vm.tableHeight}})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }